import { observable, action, toJS } from 'mobx';
import {IService, Context} from 'egg';
import ListService, { IDemoItemData } from '../../services/list';
import {IStoryDataOut} from '../../../service/contentServer';
import {waAction} from '../../common/wastat';

export interface IArticleStoreInitConfig {
  itemId: string;
  story?: IStoryDataOut;
  config?: any;
  scriptSrc?: any;
}
export default class ArticleStore {
  public story?: IStoryDataOut;
  public itemId: string;
  public config: any;
  public scriptSrc: any;

  private root: any;

  constructor(root: any, initialState: IArticleStoreInitConfig) {
    this.root = root;
    this.itemId = initialState.itemId;
    this.story = initialState.story || null;
    this.config = initialState.config || null;
    this.scriptSrc = initialState.scriptSrc || null;

    if (process.env.BROWSER) {
      window._STORY = this.story;
    }
    // console.log('ArticleStore,init:', this.story);
  }

  @action.bound
  public async ssrInit(ctx: Context, initialState: IArticleStoreInitConfig) {
    this.itemId = initialState.itemId;
    this.story = await ctx.service.contentServer.getStoryItem(initialState.itemId);
    this.config = await ctx.service.adService.getAdConfig();
    this.scriptSrc = await ctx.service.adService.getSrciptSrc();
  }

  public toJson() {
    return {
      itemId: this.itemId,
      story: this.story,
      config: this.config,
      scriptSrc: this.scriptSrc,
    };
  }

}

export function statClickOrigin(url: string) {
  waAction({
    ac_name: 'read_source',
    ac_type: 'reading',
    pos: 'read_source',
    jumpurl: url,
  });
}
